import React, { useState, useEffect } from 'react';
import WelcomeView from './components/Welcome/WelcomeView';
import QuestionView from './components/Questionnaire/QuestionView';
import ResultsView from './components/Results/ResultsView';

function App() {
  const [stage, setStage] = useState('welcome'); // welcome, questions, results
  const [profileData, setProfileData] = useState(null);

  // Debugging log to ensure state changes are tracked
  useEffect(() => {
    if (profileData) {
      console.log("Profile Data Captured:", profileData);
    }
  }, [profileData]);

  const handleStart = () => {
    setStage('questions');
  };

  const handleComplete = (data) => {
    setProfileData(data);
    setStage('results');
  };

  const handleRestart = () => {
    setProfileData(null);
    setStage('welcome');
  };

  return (
    <div className="font-sans antialiased bg-white min-h-screen">
      {stage === 'welcome' && (
        <WelcomeView onStart={handleStart} />
      )}
      
      {stage === 'questions' && (
        <QuestionView onComplete={handleComplete} />
      )}

      {stage === 'results' && profileData && (
        <ResultsView data={profileData} onRestart={handleRestart} />
      )}
    </div>
  );
}

export default App;